import httpCommon from "./http-common";

// Get all quotation items
const getAllQuotations = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/quotations/${businessId}?skip=${skip}&limit=${limit}`);
};

const getAllRecentQuotations = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/recentQuotations/${businessId}?skip=${skip}&limit=${limit}`);
};

// Get quotation item count
const getAllQuotationsCount = () => {
  return httpCommon.get("/v1/get/count/quotations");
};

const getQuotationsTotalValue = () => {
  return httpCommon.get("/v1/get/totalValue/quotations");
};

const getQuotationById = (id: number) => {
  return httpCommon.get(`/v1/get/quotation/${id}`);
};

// Create quotation
const createQuotation = (data: any, businessId: number) => {
  return httpCommon.post(`/v1/add/quotation/${businessId}`, data);
};

// Update specific quotation item
const updateSpecificQuotation = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/quotation/${id}`, data);
};

// Delete quotation
const deleteQuotation = (id: number) => {
  return httpCommon.delete(`/v1/delete/quotation/${id}`);
};

// Admin functions
const getAllQuotationsAsAdminUser = (skip = 0) => {
  return httpCommon.get(`/v1/admin/get/quotations?skip=${skip}`);
};

const getAllQuotationsCountAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/count/quotations");
};

const getQuotationsTotalValueAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/totalValue/quotations");
};

const QuotationService = {
    getAllQuotations,
    getAllRecentQuotations,
    getAllQuotationsCount,
    getQuotationsTotalValue,
    getQuotationById,
    createQuotation,
    updateSpecificQuotation,
    deleteQuotation,
    getAllQuotationsAsAdminUser,
    getAllQuotationsCountAsAdminUser,
    getQuotationsTotalValueAsAdminUser,
};
export default QuotationService;
